module.exports = __webpack_public_path__ + "static/Place-Asset-MT-8273fff31a4903719aed4e58e0d3987b.png";